import {Tabs as T} from "@mui/material";
import {styled} from "@mui/material/styles";

const Tabs = styled((props) => (
    <T
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 40,
        width: '100%',
        backgroundColor: 'rgb(0,174,239)',
    },
});


export default Tabs;